import { render } from "./PatronsView.vue?vue&type=template&id=8366be8e&scoped=true"
import script from "./PatronsView.vue?vue&type=script&lang=js"
export * from "./PatronsView.vue?vue&type=script&lang=js"

import "./PatronsView.vue?vue&type=style&index=0&id=8366be8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8366be8e"]])

export default __exports__